import { LoaderCircleIcon } from 'lucide-react'

import { ErrorBoundary } from '@/shared/components/ErrorBoundary'
import { Modal, ModalContent } from '@/shared/components/ui/modal'

import {
	ScenarioItemProvider,
	useScenarioItemContext,
} from './ScenarioItemProvider'
import ScenarioModalForm from './ScenarioModalForm'

export const ScenarioModal = ({
	isOpen,
	close,
	scenarioId,
}: {
	isOpen: boolean
	close: () => void
	scenarioId: string
}) => (
	<ScenarioItemProvider scenarioId={scenarioId}>
		<ScenarioModalContent isOpen={isOpen} close={close} />
	</ScenarioItemProvider>
)

const ScenarioModalContent = ({
	isOpen,
	close,
}: {
	isOpen: boolean
	close: () => void
}) => {
	const { isLoading } = useScenarioItemContext()

	return (
		<Modal open={isOpen} onOpenChange={(open) => !open && close()}>
			<ModalContent className='h-[calc(100vh-2rem)] max-w-5xl p-0'>
				<ErrorBoundary>
					{isLoading ? (
						<div className='flex h-full items-center justify-center'>
							<LoaderCircleIcon className='animate-spin' />
						</div>
					) : (
						<ScenarioModalForm />
					)}
				</ErrorBoundary>
			</ModalContent>
		</Modal>
	)
}
